import Layout from './components/Layout';
import GlobalStyles from './styles/GlobalStyles';

function App() {
  return (
    <div className="App">
      <Layout/>
      <GlobalStyles/>
    </div>
  );
}

export default App;
